import noop from 'lodash/noop';
import { map } from 'rxjs/operators';
import { RxSocketUrls } from '@Constants/CommonConstants';
import SocketBroker from '@Services/SocketBroker';
import ResultsInterface from '@Services/ResultsInterface';

export const runSearch = ({ searchId, requestId, queryFactItem, context, databases = [] }) => {
  const params = {
    queryFactItem,
    context,
    databases,
    searchId,
    requestId,
  };
  let searchFinished = false;
  let searchCanceled = false;
  let searchCancel = noop;

  // Callback for WS
  const searchHandler =
    (resolve) =>
    ({ payload = {} }) => {
      const {
        searchId: payloadSearchId,
        resultName,
        resultSize: resultsCount, // We get resultSize from BE, but PriorityWatcher uses resultsCount ...
      } = payload;

      if (searchId !== payloadSearchId || !resultName) {
        return;
      }

      searchFinished = true;
      resolve({ ...payload, resultsCount });
      searchCancel();
    };

  const promise = new Promise((resolve, reject) => {
    try {
      Logger.info('Reaxys Examples Search request:', params);

      // Subscribe to WS
      const unsubscribe = SocketBroker.observe(RxSocketUrls.ChannelsUrls.SearchInfo, searchHandler(resolve));

      // Send WS
      SocketBroker.send({ send: RxSocketUrls.AdvancedQuery }, { searchId, params });

      // Cancel WS / Unsubscribe
      searchCancel = () => {
        if (searchCanceled) {
          return;
        }
        searchCanceled = true;
        if (!searchFinished) {
          SocketBroker.send({ send: RxSocketUrls.CancelSearch }, { searchId });
        }
        unsubscribe();
      };
    } catch (error) {
      reject(error);
    }
  });

  return {
    promise,
    cancel: searchCancel,
  };
};

const prepareResultsPromise = ({ resultSize, resultName, databaseId, context, hitSetKey, firstItem, lastItem }, resultsHandler) =>
  ResultsInterface.getResults(
    {
      resultName,
      databaseId,
      context,
      hitSetKey,
      firstItem: firstItem || 1,
      lastItem: lastItem || resultSize,
    },
    true
  ).pipe(map(({ data }) => resultsHandler(data)));

export const getResults = ({ resultSize, resultName, databaseId, context, hitSetKey, firstItem, lastItem }, onUpdate = () => {}) => {
  let items = [];
  const resultsHandler = (results) => {
    items = items.concat(results);
    onUpdate(items);
    return items;
  };
  const subject = prepareResultsPromise({ resultSize, resultName, databaseId, context, hitSetKey, firstItem, lastItem }, resultsHandler);
  return {
    promise: new Promise((resolve, reject) => {
      subject.subscribe({
        next: (data) => resolve(data),
        error: reject,
      });
    }),
    cancel: subject.cancel,
  };
};

export const getResultsWithoutComposeItems = (
  { resultSize, resultName, databaseId, context, hitSetKey, firstItem, lastItem },
  onUpdate = () => {}
) => {
  const resultsHandler = (items) => {
    onUpdate(items);
  };
  const subject = prepareResultsPromise({ resultSize, resultName, databaseId, context, hitSetKey, firstItem, lastItem }, resultsHandler);
  return {
    promise: new Promise((resolve, reject) => {
      subject.subscribe({
        next: (data) => resolve(data),
        error: reject,
      });
    }),
    cancel: subject.cancel,
  };
};
